import { useEffect, useState } from "react";
import {
  getSmsTemplates,
  getSmsTemplateEnabledMap,
  rehydrateSmsTemplates,
  resetSmsTemplates,
  subscribeSmsTemplates,
  updateSmsTemplate,
  updateSmsTemplateEnabled,
} from "../lib/smsTemplates";

export function useSmsTemplates() {
  const [templates, setTemplates] = useState(getSmsTemplates());
  const [templateEnabledMap, setTemplateEnabledMap] = useState(
    getSmsTemplateEnabledMap()
  );

  useEffect(() => {
    void rehydrateSmsTemplates();

    const unsubscribe = subscribeSmsTemplates(() => {
      setTemplates(getSmsTemplates());
      setTemplateEnabledMap(getSmsTemplateEnabledMap());
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    templates,
    templateEnabledMap,
    updateSmsTemplate,
    updateSmsTemplateEnabled,
    resetSmsTemplates,
  };
}